<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card header-class="redmfu" >
                <div slot="header">
                  <strong>
                    ค้นหารายชื่อผู้มีสิทธิ์ขึ้นรับพระราชทานปริญญาบัตร ประจำปีการศึกษา 2567
                    <br />Graduation checklist for the Commencement Ceremony
                  </strong>
                </div>
                <b-row>
                  <b-col lg="4" >
                    <b-form-group
                      label="Filter"
                      label-cols-sm="2"
                      label-align-sm="right"
                      label-size="sm"
                      label-for="filterInput"
                      class="mb-0"
                    >
                      <b-input-group >
                        <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Search..."
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6" ></b-col>
                </b-row>
                <b-row><b-col lg="12">&nbsp;&nbsp;</b-col> </b-row>
                <b-row >
                  <b-col lg="4">
                    <b-table
                      striped
                      hover
                      :items="items"
                      :fields="fields"
                      :filter="filter"
                      :per-page="perPage"
                      @filtered="onFiltered"
                      :select-mode="selectMode"
                      responsive="sm"
                      ref="selectableTable"
                      selectable
                      @row-selected="onRowSelected"
                    >
                    </b-table>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2"></b-col>
                  <b-col sm="7" md="6" class="my-1">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                  <!--                  <b-col lg="2">sdfasdf</b-col>-->
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: { YimoVueEditor },
  name: "CreateGeneral",
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      selectMode: 'single',
      selected: [],
      fields: [
        {
          key: "STUDENTCODE",
          label: "รหัสประจำตัวนักศึกษา (STUDENTCODE)",
          formatter: "STUDENTCODE"
        },
        {
          key: "STUDENTNAME",
          label: "         ชื่อ (Name)         ",
          formatter: "STUDENTNAME"
        },
        /*   {
             key: "ACADYEAR",
             label: "         มีสิทธิ์เข้ารับพระราชทานปริญญาบัตร ประจำปีการศึกษา (Academic Year)        ",
             formatter: "ACADYEAR"
           },
           {
             key: "GLINK",
             label: "ลิงค์แจ้งความประสงค์ (Commencement Ceremony Registration System)",
             // html: 'This is <i>raw <strong>HTML</strong></i> <span style="color:red">content</span>'
             // formatter: "<a href>GLINK</a>"
           },
             {
               key: "FACULTYNAME",
               label: "สำนักวิชา (FACULTYNAME)",
               formatter: "FACULTYNAME"
             },
             {
               key: "LEVELGROUPNAME",
               label: "ปริญญา (LEVELGROUP)",
               formatter: "LEVELGROUPNAME"
             },
             {
               key: "ORDER_NO",
               label: "ลำดับการรับปริญญา (ORDER NO)",
               formatter: "ORDER_NO"
             }*/
      ],
      items: [],
      filter: null
    };
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    //console.log("totalRows==", this.totalRows);
  },
  methods: {
    onRowSelected(items) {
      //this.selected = items
      //console.log("==",items[0].GLINK)
      window.location.href = items[0].GLINK;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getStatistic() {
      api
        .getStatisticSearch()
        .then(res => {
          this.items = res.data.data;
          // console.log("item==", this.items);
          //console.log(res);
        })
        .catch(err => {
          console.log("getStatistic", err.toString());
        });
    }
  },
  // mounted() {},
  created() {
    this.getStatistic();
    api.onSetHeader();
  }
};
</script>
<style>
</style>
